import { NgModule } from '@angular/core';
import { ZButton } from './z-button.component';



@NgModule({
  declarations: [ZButton],
  imports: [
  ],
  exports: [ZButton]
})
export class ZButtonModule { }
